import React from 'react';
import { Header, PageContainer, PageContent, Sidebar } from '../../layouts';
import { DataGrid, TitleLarge } from '../../components';
import { mock_users } from '../../utils/data';
import { userConfig } from '../../utils/configs';

const UsersPage = () => {
	return (
		<>
			<Header />
			<PageContainer>
				<Sidebar />
				<PageContent>
					<TitleLarge>Benutzer</TitleLarge>
					<DataGrid
						data={mock_users}
						config={userConfig}
						keyExtractor={(user) => user.user_id}
					/>
				</PageContent>
			</PageContainer>
		</>
	);
};

export default UsersPage;
